import {
  getNameDescriptionTableColumn,
  getOsArch,
  getProjectTableColumn,
  getTimeTableColumn,
  getStatusTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import SystemIcon from '@/sections/SystemIcon'
export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'name',
        hideField: true,
        edit: false,
        editDesc: false,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
        formatter: ({ row }) => {
          return row.name
        },
      }),
      getOsArch({
        hidden: () => {
          return this.$isScopedPolicyMenuHidden('server_hidden_columns.os_arch')
        },
      }),
      getStatusTableColumn({
        minWidth: 180,
        statusModule: 'server',
        hidden: () => {
          return this.$isScopedPolicyMenuHidden('server_hidden_columns.status')
        },
      }),
      {
        field: 'os_type',
        title: this.$t('table.title.os'),
        width: 50,
        slots: {
          default: ({ row }) => {
            const tooltip = row.os_type
            const name = row.os_type
            return [
              <SystemIcon tooltip={tooltip} name={name} />,
            ]
          },
        },
      },
      getCopyWithContentTableColumn({
        field: 'ip_addr',
        title: 'IP',
        minWidth: 140,
      }),
      getProjectTableColumn({
        hidden: () => {
          return this.$isScopedPolicyMenuHidden('server_hidden_columns.tenant')
        },
      }),
      getTimeTableColumn({
        hidden: () => {
          return this.$isScopedPolicyMenuHidden('server_hidden_columns.created_at')
        },
      }),
    ]
  },
}
